import(/* webpackMode: "eager", webpackExports: ["default","iconNames"] */ "/vercel/path0/node_modules/lucide-react/dist/esm/DynamicIcon.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
